import { render } from "./ForgotSubmit.vue?vue&type=template&id=5f0c31f8"
import script from "./ForgotSubmit.vue?vue&type=script&lang=js"
export * from "./ForgotSubmit.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__